import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=1d410960&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=ts"
export * from "./Packages.vue?vue&type=script&lang=ts"
import style0 from "./Packages.vue?vue&type=style&index=0&id=1d410960&prod&scoped=true&lang=css"
import style1 from "./Packages.vue?vue&type=style&index=1&id=1d410960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d410960",
  null
  
)

export default component.exports